const getPartner = state => state.partner;
const getQR = state => state.qrCode;
const getWithKeyBoard = state => state.withKeyBoard;
const getPartnerMovingBoxes = state => state.partnerMovingBoxes;

export default {
  getPartner,
  getQR,
  getWithKeyBoard,
  getPartnerMovingBoxes
};
